import { useParams as useReactParams } from 'react-router-dom';
import { useMemo } from 'react';
import useStorefront from '../../modules/storefront/hooks/useStorefront';
import WindowResource from '../../services/resources/WindowResource';

export default function useParams() {
  const params = useReactParams();
  const { isStorefront } = useStorefront();

  const slug = useMemo(() => {
    const rawSlug = params.slug;
    const basePath = WindowResource.basePath;
    if (!isStorefront || !rawSlug || !basePath) return rawSlug;
    if (!basePath.startsWith(rawSlug)) return rawSlug;

    return rawSlug.slice(basePath.length).replace(/^\//, '') || rawSlug;
  }, [params.slug, isStorefront]);

  return {
    ...params,
    slug,
  };
}
